var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: {
        id: "mediaManagerModal",
        tabindex: "-1",
        role: "dialog",
        "aria-labelledby": "mediaManagerModalLabel",
        "aria-hidden": "true",
      },
    },
    [
      _c("div", { staticClass: "modal-dialog modal-lg" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h3", { staticClass: "modal-title" }, [
              _c("i", { staticClass: "feather icon-file mr-05" }),
              _vm._v(_vm._s(_vm.__("media_manager.title"))),
            ]),
            _vm._v(" "),
            _vm._m(0),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "modal-body" }, [
            _c("div", { staticClass: "d-flex" }, [
              _c("div", { staticClass: "col-md-8" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.search_term,
                        expression: "search_term",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      name: "search_term",
                      id: "search_term",
                      placeholder: "Enter a keyword to search",
                    },
                    domProps: { value: _vm.search_term },
                    on: {
                      keyup: _vm.search,
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.search_term = $event.target.value
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  {
                    staticClass: "list-group overflow-y-scroll scroll",
                    staticStyle: {
                      "min-height": "500px",
                      "max-height": "500px",
                    },
                  },
                  [
                    _c("li", { staticClass: "list-group-item font-small-3" }, [
                      _c("div", { staticClass: "d-flex" }, [
                        _c("div", { staticClass: "width-50-per" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.__("media_manager.file"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "width-30-per" }, [
                          _c("strong", [
                            _vm._v(_vm._s(_vm.__("globals.type"))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "width-20-per" }),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.mediafilelist, function (file) {
                      return _c(
                        "li",
                        {
                          key: file.id,
                          staticClass: "list-group-item font-small-3",
                        },
                        [
                          _c("div", { staticClass: "d-flex" }, [
                            _c("div", { staticClass: "width-50-per" }, [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: file.media_file.url,
                                    target: "_blank",
                                  },
                                },
                                [_vm._v(_vm._s(file.title))]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "width-30-per" }, [
                              _vm._v(
                                _vm._s(_vm.fileType[file.media[0].mime_type])
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "text-right width-20-per ml-auto",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-pill badge-success",
                                    staticStyle: { display: "none" },
                                    attrs: { id: "link_copied" + file.id },
                                  },
                                  [_vm._v("Copied")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.copylink(
                                          _vm.siteUrl + file.media_file.url,
                                          file.id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "feather icon-link",
                                      staticStyle: { "font-size": "0.9em" },
                                      attrs: {
                                        title: _vm.__(
                                          "media_manager.copy_link"
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.deleteMedia(file.id)
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "feather icon-trash-2",
                                      staticStyle: { "font-size": "0.9em" },
                                      attrs: {
                                        title: _vm.__(
                                          "media_manager.delete_media"
                                        ),
                                      },
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-4" }, [
                _c("h3", [
                  _c("i", { staticClass: "feather icon-upload mr-05" }),
                  _vm._v(_vm._s(_vm.__("media_manager.add_file"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("label", { attrs: { for: "title" } }, [_vm._v("Title")]),
                  _vm._v(" "),
                  _c("input", {
                    staticClass: "form-control",
                    attrs: { name: "mediatitle", id: "mediatitle" },
                    on: { keyup: _vm.characterCheck },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "help-block text-muted font-small-1" },
                    [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.__("media_manager.num_chars_left")) +
                          " " +
                          _vm._s(_vm.maxCharacters) +
                          "\n                            "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("input", {
                  attrs: { type: "file", name: "mediafile", id: "mediafile" },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "help-block text-muted font-small-1",
                    staticStyle: { display: "none" },
                    attrs: { id: "validation" },
                  },
                  [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.__("media_manager.media_upload_para")) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex flex-row-reverse pt-1" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-success waves-effect waves-light",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.save()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.__("globals.save")) +
                          " "
                      ),
                      _c("i", { staticClass: "feather icon-check-circle" }),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }